// Zdarzenia domenowe publikowane przez outbox do AutoMQ/Kafki.
export const TOPICS = {
    booking: "b00k.booking.v1",
    payment: "b00k.payment.v1",
    tenant: "b00k.tenant.v1",
    /** Kody SMS i linki weryfikacyjne — platformowe, poza kontekstem tenanta. */
    auth: "b00k.auth.v1",
    /** Abonament operatora: faktury i stan subskrypcji. Konsumentem będzie S3113R. */
    billing: "b00k.billing.v1",
};
export const TOPIC_FOR = {
    "booking.created": TOPICS.booking,
    "booking.rescheduled": TOPICS.booking,
    "booking.cancelled": TOPICS.booking,
    "booking.restored": TOPICS.booking,
    "payment.captured": TOPICS.payment,
    "tenant.registered": TOPICS.tenant,
    "auth.otp.requested": TOPICS.auth,
    "auth.email.verification": TOPICS.auth,
    "invoice.issued": TOPICS.billing,
    "subscription.activated": TOPICS.billing,
    "subscription.past_due": TOPICS.billing,
    "subscription.canceled": TOPICS.billing,
};
//# sourceMappingURL=events.js.map